document.addEventListener('DOMContentLoaded', function () {
  // Handle first slide for immediate loading (LCP optimization)
  var firstSlide = document.querySelector('#main-carousel .splide__slide:first-child');
  if (firstSlide) {
    var firstImg = firstSlide.querySelector('img[data-splide-lazy]');
    var firstPicture = firstSlide.querySelector('picture');

    if (firstImg && firstPicture) {
      var sources = firstPicture.querySelectorAll('source[data-splide-lazy]');
      sources.forEach(function(source) {
        source.srcset = source.getAttribute('data-splide-lazy');
        source.removeAttribute('data-splide-lazy');
      });

      firstImg.src = firstImg.getAttribute('data-splide-lazy');
      firstImg.setAttribute('fetchpriority', 'high');
      firstImg.setAttribute('loading', 'eager');
      firstImg.removeAttribute('data-splide-lazy');
    }
  }

  var splide = new Splide('#main-carousel', {
    type: 'loop',
    heightRatio: 0.5625,
    cover: true,
    lazyLoad: 'nearby',
    preloadPages: 1,
    video: {
      loop: false,
      mute: false,
      disableOverlayUI: true,
      playerOptions: {
        youtube: {
          width: '100%',
          height: '100%',
        }
      }
    },
    breakpoints: {
      640: {
        heightRatio: 0.5625,
        preloadPages: 0,
      },
    },
  });

  splide.on('lazyload:loaded', function(img, slide) {
    img.style.opacity = '1';
    img.classList.add('is-loaded');
  });

  splide.on('mounted', function() {
    var videos = document.querySelectorAll('#main-carousel .splide__video, #main-carousel iframe[src*="youtube"]');
    videos.forEach(function(video) {
      video.style.cssText = 'width: 100%; height: 100%; left: 0; top: 0; position: absolute;';
    });
  });

  splide.mount(window.splide.Extensions);

  splide.on('video:loaded', function(video) {
    var videoElement = video.container.querySelector('iframe');
    if (videoElement) {
      videoElement.style.cssText = 'width: 100% !important; height: 100% !important; left: 0 !important; top: 0 !important; position: absolute !important;';
    }
  });
});